import { BottomSheet, Text, type UseModalState } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { addDays, format, setHours, setMinutes, setSeconds, startOfDay } from "date-fns";

interface SubmitDocumentsLaterInterviewBookedBottomSheetProps {
  modalState: UseModalState;
  interviewDate: Date;
  onClose: () => void;
}

export function SubmitDocumentsLaterInterviewBookedBottomSheet(
  props: SubmitDocumentsLaterInterviewBookedBottomSheetProps
) {
  const { modalState, interviewDate, onClose } = props;

  // Document deadline is 4 PM the day before the interview
  const dayBeforeInterview = addDays(startOfDay(interviewDate), -1);
  const documentDeadline = setSeconds(setMinutes(setHours(dayBeforeInterview, 16), 0), 0);

  const deadlineDayFormatted = format(documentDeadline, "EEEE");
  const deadlineDateFormatted = format(documentDeadline, "MMMM d");
  const interviewDayFormatted = format(interviewDate, "EEEE");
  const interviewDateFormatted = format(interviewDate, "MMMM d");

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={onClose} />}
      footer={
        <DialogFooter orientation="vertical">
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={false}
            onClick={onClose}
          >
            Got it
          </LoadingButton>
        </DialogFooter>
      }
      onClose={onClose}
    >
      <Box sx={{ px: 7, py: 6 }}>
        <Stack spacing={6}>
          <Text variant="h4" sx={{ fontWeight: 500 }}>
            Interview booked!
          </Text>

          <Text color={(theme) => theme.palette.text.secondary}>
            Valid documents must be submitted by 4pm, {deadlineDayFormatted},{" "}
            {deadlineDateFormatted} for your interview on {interviewDayFormatted},{" "}
            {interviewDateFormatted}.
          </Text>
        </Stack>
      </Box>
    </BottomSheet>
  );
}
